import { ComponentPropsWithoutRef } from 'react'
import { LinkButton } from '@/atoms/Button'
import { PayItForwardOutlineIcon } from '@/atoms/Icons/PayItForwardOutlineIcon'
import { Image } from '@/atoms/Image'
import { PaddedContainer } from '@/atoms/PaddedContainer'
import { Display, LabelLG, ParagraphXL } from '@/atoms/Text'
import { getCloudinaryImageUrl } from '@/utils/Cloudinary'
import { useSafeTrack } from '@/utils/analytics'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

export const PifHero = () => {
  const { t } = useTranslate('pif')
  const track = useSafeTrack()

  const handleGetStartedClick = () => {
    track('PIF Explainer Get Started Clicked')
  }

  return (
    <div
      className="bg-cover bg-center bg-no-repeat md:pt-12"
      style={{
        backgroundImage: `url(${getCloudinaryImageUrl({
          path: `/v1706800638/angel-studios/pif/f57b5fa7388fe7ad1213da7c4e95c95e.png`,
        })})`,
      }}
    >
      <PaddedContainer className="flex h-full min-h-screen flex-col items-end lg:flex-row-reverse">
        <div className="flex w-full flex-col items-end lg:w-1/2 3xl:w-full">
          <Image
            alt="Pay it Forward on your phone"
            width={1709}
            height={2279}
            className="hidden lg:block 3xl:-mr-32"
            src="q_auto/v1706739711/angel-app/Cabrini/3ebc280a3536040a172eaee7695956fa.png"
          />
          <Image
            alt="Pay it Forward on your phone (mobile)"
            width={599}
            height={1021}
            className="-mx-8 -mt-10 block md:-mx-16 lg:hidden"
            src="q_auto/v1706740227/angel-app/Cabrini/Hand_Holding_iPhone_Mockup_1.png"
          />
        </div>
        <div className="-mt-40 flex h-full w-full flex-col items-start justify-center gap-4 pb-12 sm:pb-20 md:-mt-96 md:px-12 lg:m-0 lg:min-h-screen lg:basis-1/2 lg:px-6 lg:py-28 3xl:px-0">
          <div
            className={
              'flex h-[72px] min-h-[72px] w-[72px] min-w-[72px] items-center justify-center rounded-3xl lg:max-h-[88px] lg:max-w-[88px]'
            }
          >
            <PayItForwardOutlineIcon size={64} color="white" />
          </div>
          <Display
            className="photon-heading-md sm:photon-heading-lg md:photon-heading-xl lg:photon-display"
            weight="bold"
            as={(p: ComponentPropsWithoutRef<'h1'>) => <h1 {...p} />}
          >
            {t('payItForward', 'Pay it Forward')}
          </Display>
          <ParagraphXL className="photon-paragraph-sm sm:photon-paragraph-md md:photon-paragraph-lg lg:photon-paragraph-xlmt-2 max-w-[545px] text-left font-[375] text-core-gray-200">
            <Translate t={t} i18nKey="angelStudiosCommitedMakingShowsAccessible">
              Angel is committed to making our shows accessible to viewers everywhere, and you can play a key role. With
              the ‘Pay It Forward’ feature, you can help support the stories you love, enabling others to experience
              them too. Your generosity ensures we can continue bringing meaningful entertainment to everyone.
            </Translate>
          </ParagraphXL>
          <LinkButton
            onClick={handleGetStartedClick}
            href="#pif-getting-started"
            className="min-h-[64px] w-fit justify-center px-6 py-[14px] font-[375] md:px-7 md:py-[17px] lg:max-w-44"
            variant="white"
          >
            <LabelLG weight="bold">{t('getStarted', 'Get Started')}</LabelLG>
          </LinkButton>
        </div>
      </PaddedContainer>
    </div>
  )
}
